<script setup>
  import { getRoundColor } from '@/services/utils'
  const props = defineProps(['roundState'])
</script>

<template>
  <v-chip
    :color="getRoundColor(roundState)"
    class="ma-2"
  >
    {{ $t(`roundStates.${roundState}`) }}
  </v-chip>
</template>